import { buildApiUrl, resolveMesApiBase } from './apiBase';
import { createApiHttpClient } from './httpClient';

export const MES_API_BASE = resolveMesApiBase(import.meta.env.VITE_MES_API_URL);

export const buildMesUrl = (path: string, params?: Record<string, string | undefined>) => {
  let normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // Strip legacy leading /mes when MES_API_BASE already routes to the MES service.
  // (e.g. MES_API_BASE="/api/mes" — appending "/mes/work-orders" would produce "/api/mes/mes/work-orders")
  if (
    MES_API_BASE &&
    MES_API_BASE !== '/mes' &&
    (normalizedPath === '/mes' || normalizedPath.startsWith('/mes/'))
  ) {
    normalizedPath = normalizedPath.slice(4); // remove "/mes" prefix
  }

  return buildApiUrl(MES_API_BASE, normalizedPath, params);
};

export const mesHttp = createApiHttpClient();
